export default __webpack_public_path__ + "static/media/app_pocket_casts.8501004e.svg";